<template>
    <div class="head-tab" :class="['tab-list' + list.length,{'tab':model == 1},
    {'zIndex-high':zIndexHigh,'fixed': isFixed,'avoid-header':isAvoidHeader}]">
        <div class="tab-item" v-for="item in list" :key="item.id"
        :class="[
        {'tab-drop': model == 2},
        {'drop': model == 2 && item.selected},
        {'active': model == 1 && item.selected}]" @click="switchTab(item.id)">{{item.name}}</div>
    </div>
</template>
<script>
    export default {
        props: {
            list: {
                type: Array,
                default: [
                    {
                        id: 1,
                        name: "星级",
                        selected: false
                    }
                ]
            },
            model: { //模式 - 1:tab,2:drop
                type: Number,
                default: 1
            },
            isCancelSelf: { //是否可取消自己
                type: Boolean,
                default: false
            },
            zIndexHigh: { //是否高层级
                type: Boolean,
                default: false
            },
            isFixed: { //是否锁顶
                type: Boolean,
                default: false
            },
            isAvoidHeader: { //是否避头
                type: Boolean,
                default: false
            },
        },
        methods:{
            //切换tab
            switchTab(itemId){
                let self = this;
                let isTrigger = false;
                for(let i=0; i<this.list.length; i++){
                    if(this.list[i].id == itemId){
                        if(this.model == 1){
                            if(self.isCancelSelf){ //可取消自身
                                this.list[i].selected = !this.list[i].selected;
                                isTrigger = true;
                            } else { //不可取消自身
                                if(!this.list[i].selected){
                                    this.list[i].selected = !this.list[i].selected;
                                    isTrigger = true;
                                }
                            }
                        } else {
                            this.list[i].selected = !this.list[i].selected;
                            isTrigger = true;
                        }
                    } else {
                        this.list[i].selected = false;
                    }
                }
                if(isTrigger){
                    this.$emit("switchTab",itemId);
                }
            },
        }
    }
</script>
<style>
    .head-tab{
        flex: 0 0 auto;
        width: 100%;
        height: 0.56rem;
        background-color: #ffffff;
        border-bottom: 1px solid #959595;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        position: relative;
        z-index: 9;
        font-size: 0.26rem;
    }
    .head-tab.fixed{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100;
    }
    .head-tab.avoid-header{
        top: 1.06rem;
    }
    .head-tab .tab-item{
        flex: 0 0 auto;
        width: 33.3%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        position: relative;
    }
    /* tab模式 */
    .head-tab.tab{
        width: 84%;
        height: 0.76rem;
        padding: 0 8%;
    }
    .head-tab.tab .tab-item{
        width: 28%;
    }
    .head-tab.tab.tab-list1{
        justify-content: center;
    }
    .head-tab.tab.tab-list2{
        width: 70%;
        padding: 0 15%;
    }
    .head-tab.tab.tab-list2 .tab-item{
        width: 33%;
    }
    .head-tab.tab.tab-list3{
        width: 84%;
        padding: 0 8%;
    }
    .head-tab.tab.tab-list3 .tab-item{
        width: 28%;
    }
    .head-tab.tab.tab-list4{
        width: 88%;
        padding: 0 6%;
    }
    .head-tab.tab.tab-list4 .tab-item{
        width: 21%;
    }
    .head-tab.tab.tab-list5{
        width: 90%;
        padding: 0 5%;
        justify-content: space-around;
    }
    .head-tab.tab.tab-list5 .tab-item{
        /* width: 19%; */
        width: auto;
    }
    .head-tab.tab.tab-list6{
        width: 98%;
        padding: 0 1%;
        justify-content: space-around;
    }
    .head-tab.tab.tab-list6 .tab-item{
        /* width: 16%; */
        width: auto;
    }
    .head-tab.tab .tab-item.active{
        color: #f0861b;
    }
    .head-tab.tab .tab-item.active:after{
        content: "";
        display: block;
        width: 100%;
        height: 4px;
        background-color: #f0861b;
        position: absolute;
        left: 0;
        bottom: -1px;
    }
    /* 下拉模式 */
    .head-tab.tab-list1 .tab-item.tab-drop{
        width: 100%;
    }
    .head-tab.tab-list2 .tab-item.tab-drop{
        width: 49.9%;
    }
    .head-tab.tab-list3 .tab-item.tab-drop{
        width: 33.3%;
    }
    .head-tab.tab-list4 .tab-item.tab-drop{
        width: 24.9%;
    }
    .head-tab.tab-list5 .tab-item.tab-drop{
        width: 19.9%;
    }
    .head-tab.tab-list6 .tab-item.tab-drop{
        width: 16.6%;
    }
    .head-tab .tab-item.tab-drop{
        border-right: 1px solid #959595;
    }
    .head-tab .tab-item.tab-drop:last-child{
        border: 0;
    }
    .head-tab .tab-item.tab-drop:after{
        flex: 0 0 auto;
        content: "";
        display: block;
        height: 0;
        width: 0;
        font-size: 0;
        line-height: 0;
        border-color: transparent;
        border-style: solid;
        border-width: 0.12rem 0.10rem 0 0.10rem;
        border-color: #676568 transparent;
        position: absolute;
        right: 0.12rem;
        top: 0.24rem;
    }
    .head-tab .tab-item.tab-drop.drop{
        color: #f0861b;
    }
    .head-tab .tab-item.tab-drop.drop:after{
        border-width: 0 0.10rem 0.12rem 0.10rem;
        border-color: #f0861b transparent;
    }
</style>



// WEBPACK FOOTER //
// src/shared/components/head-tab.vue